/* Robo-Repair – Ratgeber: kleine Umbauten am fertigen HTML, die CSS allein nicht kann.
   Quelle: rd-wawi/shopify-sync/theme/ – hochladen mit ratgeber-theme.js.
   KATS wird beim Hochladen aus categories.js eingesetzt. */
(function () {
  var KATS = [{"slug":"fehlersuche","name":"Fehlersuche & Soforthilfe","kurz":"Etwas geht nicht mehr","intro":"Das Gerät meldet einen Fehler, saugt schlechter, riecht oder bleibt stehen. Hier findest du die Ursache – geordnet nach dem, was du zuerst prüfen solltest."},{"slug":"pflege-und-wartung","name":"Pflege & Wartung","kurz":"Damit es gar nicht erst kaputtgeht","intro":"Die meisten Defekte sind vermeidbar. Welche Teile wann fällig sind, wie du Kalk, Geruch und Verschleiß vorbeugst – und was eine Pause im Urlaub mit dem Akku macht."},{"slug":"einrichtung-und-navigation","name":"Einrichtung & Navigation","kurz":"Karte, Sperrzonen, Hindernisse","intro":"Karte, Sperrzonen, Etagen, WLAN: Wer den Roboter einmal richtig einrichtet, hat jahrelang Ruhe. Hier steht, worauf es dabei ankommt."},{"slug":"ersatzteile","name":"Ersatzteile richtig auswählen","kurz":"Das passende Teil finden","intro":"Welches Modell habe ich, welches Teil passt, Original oder Nachbau – und was du selbst wechseln kannst."},{"slug":"kaufberatung","name":"Kaufberatung & Vergleiche","kurz":"Vor der Entscheidung","intro":"Absaugstation oder nicht, refurbished oder neu, welches Modell für Tierhaare: Entscheidungshilfen ohne Werbesprache."},{"slug":"werkstatt-und-service","name":"Werkstatt & Service","kurz":"Wenn wir übernehmen","intro":"Wann sich eine Reparatur lohnt, was wir instand setzen und wie dein Gerät zu uns kommt."}];

  function los() {
    // ---- Beitrag
    var inhalt = document.querySelector('.article-template__content');
    if (inhalt) {
      // Inhaltsverzeichnis: Überschrift + Liste zu einem Kasten zusammenfassen
      Array.prototype.forEach.call(inhalt.querySelectorAll('h2'), function (h) {
        if (!/Inhaltsverzeichnis/i.test(h.textContent) || h.closest('.rra-toc')) return;
        var huelle = h.closest('nav, .toc, .rd-inhaltsverzeichnis');
        if (huelle && huelle !== inhalt && inhalt.contains(huelle)) { huelle.classList.add('rra-toc'); return; }
        var liste = h.nextElementSibling;
        if (!liste || !/^(UL|OL|NAV)$/.test(liste.tagName)) return;
        var nav = document.createElement('nav');
        nav.className = 'rra-toc';
        nav.setAttribute('aria-label', 'Inhaltsverzeichnis');
        h.parentNode.insertBefore(nav, h);
        nav.appendChild(h);
        nav.appendChild(liste);
      });

      // Tabellen: Scroll-Hülle, damit breite Tabellen auf dem Handy nicht die Seite sprengen
      Array.prototype.forEach.call(inhalt.querySelectorAll('table'), function (t) {
        if (t.parentNode.classList.contains('rra-tab')) return;
        var d = document.createElement('div');
        d.className = 'rra-tab';
        t.parentNode.insertBefore(d, t);
        d.appendChild(t);
      });

      // „Zurück zum Blog“ führt zur Ratgeber-Übersicht
      var zurueck = document.querySelector('.article-template__back .article-template__link');
      if (zurueck) {
        zurueck.setAttribute('href', '/pages/ratgeber');
        var knoten = zurueck.childNodes[zurueck.childNodes.length - 1];
        if (knoten && knoten.nodeType === 3) knoten.textContent = ' Zur Ratgeber-Übersicht';
      }
    }

    // ---- Blog- und Kategorie-Übersicht: Kategorie-Leiste unter die Überschrift
    var blog = document.querySelector('.main-blog');
    if (blog && KATS.length && !blog.querySelector('.rra-nav')) {
      var titel = blog.querySelector('h1');
      var treffer = location.pathname.match(/\/tagged\/([^\/?#]+)/);
      var slug = treffer ? decodeURIComponent(treffer[1]) : '';
      var aktiv = null;
      KATS.forEach(function (k) { if (k.slug === slug) aktiv = k; });

      var nav = document.createElement('nav');
      nav.className = 'rra-nav';
      nav.setAttribute('aria-label', 'Ratgeber-Themen');
      var basis = (location.pathname.match(/^(.*\/blogs\/[^\/]+)/) || ['', '/blogs/news'])[1];
      function link(text, href, klasse) {
        var a = document.createElement('a');
        a.textContent = text;
        a.href = href;
        if (klasse) a.className = klasse;
        nav.appendChild(a);
      }
      link('Alle Beiträge', basis, slug ? '' : 'rra-aktiv');
      KATS.forEach(function (k) { link(k.name, basis + '/tagged/' + k.slug, k.slug === slug ? 'rra-aktiv' : ''); });
      link('Ratgeber-Übersicht →', '/pages/ratgeber', 'rra-hub');

      var intro = document.createElement('p');
      intro.className = 'rra-intro';
      if (aktiv && titel) {
        var auge = document.createElement('p');
        auge.className = 'rra-auge';
        auge.textContent = aktiv.kurz;
        titel.parentNode.insertBefore(auge, titel);
        titel.textContent = aktiv.name;
        intro.textContent = aktiv.intro;
      } else {
        intro.textContent = 'Was wir in der Werkstatt und im Ersatzteilversand über Saugroboter gelernt haben – such dir das Thema, das gerade passt.';
      }
      if (titel) {
        titel.parentNode.insertBefore(intro, titel.nextSibling);
        intro.parentNode.insertBefore(nav, intro.nextSibling);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los);
  else los();
})();
